/**
 * Stat definitions for the core content pack.
 *
 * Stats are dynamic character attributes that can change during gameplay.
 */

import type { StatDefinition, StatCategory } from '@idle-depths/shared';

/**
 * Type guard for StatDefinition.
 */
export function isStatDefinition(item: unknown): item is StatDefinition {
  if (typeof item !== 'object' || item === null) {
    return false;
  }

  const obj = item as Record<string, unknown>;

  return (
    typeof obj.id === 'string' &&
    typeof obj.name === 'string' &&
    typeof obj.icon === 'string' &&
    typeof obj.category === 'string' &&
    ['vital', 'combat', 'gathering', 'crafting', 'misc'].includes(obj.category as string) &&
    typeof obj.defaultValue === 'number' &&
    (obj.defaultMaximum === null || typeof obj.defaultMaximum === 'number') &&
    typeof obj.isVisible === 'boolean' &&
    typeof obj.displayOrder === 'number'
  );
}

/**
 * Health stat definition.
 *
 * The primary vital stat. When it reaches 0, the character is incapacitated.
 */
export const HEALTH_STAT: StatDefinition = {
  id: 'health',
  name: 'Health',
  icon: 'heart',
  category: 'vital' as StatCategory,
  defaultValue: 100,
  defaultMaximum: 100,
  isVisible: true,
  displayOrder: 0,
};

/**
 * All core stats.
 */
export const CORE_STATS: StatDefinition[] = [HEALTH_STAT];
